import { Box, Icon } from "@chakra-ui/react"
import React from "react"
import { BsDashCircleFill } from 'react-icons/bs';

export const FileDeleterWrapper = ({ removeItem, index, children }) => {
    return <>
        <Box float="right" mb="-2" mr="-2" position="relative" zIndex="1"
            onClick={() => {
                removeItem(index)
            }}>
            <Icon color="red" fontSize="md" cursor="pointer" as={BsDashCircleFill} />
        </Box>
        {children}
    </>
}
